import { pendoTrack } from "./pendoUtil";
import Cookies from "js-cookie";

export const helpNavigation = (regionId, isSupport = false) => {
  switch (regionId) {
    case "840":
      return isSupport ? "https://reveal-help.verizonconnect.com/hc/en-us/articles/360010566039 " : "https://reveal-help.verizonconnect.com/hc/en-us";
    case "124":
      return isSupport ? "https://reveal-help.verizonconnect.com/hc/en-ca/articles/360010566039 " : "https://reveal-help.verizonconnect.com/hc/en-ca";
    case "36":
      return isSupport ? "https://reveal-help.verizonconnect.com/hc/en-au/articles/360010566039 " : "https://reveal-help.verizonconnect.com/hc/en-au";
    case "554":
      return isSupport ? "https://reveal-help.verizonconnect.com/hc/en-nz/articles/360010566039 " : "https://reveal-help.verizonconnect.com/hc/en-nz";
    case "826":
      return isSupport ? "https://reveal-help.verizonconnect.com/hc/en-gb/articles/360010566039" : "https://reveal-help.verizonconnect.com/hc/en-gb";
    case "528":
    case "56":
      return isSupport ? "https://reveal-help.verizonconnect.com/hc/nl-nl/articles/360010566039" : "https://reveal-help.verizonconnect.com/hc/nl-nl";
    case "372":
      return isSupport ? "https://reveal-help.verizonconnect.com/hc/en-ie/articles/360010566039" : "https://reveal-help.verizonconnect.com/hc/en-ie";
    case "250":
      return isSupport ? "https://reveal-help.verizonconnect.com/hc/fr-fr/articles/360010566039" : "https://reveal-help.verizonconnect.com/hc/fr-fr";
    case "276":
    case "40":
      return isSupport ? "https://reveal-help.verizonconnect.com/hc/de-de/articles/360010566039" : "https://reveal-help.verizonconnect.com/hc/de-de";
    case "380": //italy it-IT
    case "620": //portugal pt-PT
    case "724": //spain es-ES
    case "616": //poland pl-PL
      return isSupport ? "https://reveal-help.verizonconnect.com/hc/articles/360010566039" : "https://reveal-help.verizonconnect.com/hc/";
    default:
      return;
  }
};

export const revealRedirectionLink = () => {
  let revealLanguage = Cookies.get("userLanguage") ? Cookies.get("userLanguage") : "en-US";
  const revealLink = findRevealRedirectionLink(Cookies.get("currentRoute"), revealLanguage);
  if (window.location.href.toString().includes("vccp-uat.ebiz.verizon.com")) {
    return `https://reveal.stage.us.fleetmatics.com/login.aspx?ReturnUrl=${revealLink}`;
  } else if (window.location.href.toString().includes("reveal.stage.us.fleetmatics.com")) {
    return `https://reveal.stage.us.fleetmatics.com/login.aspx?ReturnUrl=${revealLink}`;
  } else if (window.location.href.toString().includes("reveal.stage.us.vzconnect.com")) {
    return `https://reveal.stage.us.vzconnect.com/login.aspx?ReturnUrl=${revealLink}`;
  } else if (window.location.href.toString().includes("reveal.us.fleetmatics.com")) {
    return `https://reveal.us.fleetmatics.com/login.aspx?ReturnUrl=${revealLink}`;
  } else if (window.location.href.toString().includes("reveal.us.vzconnect.com")) {
    return `https://reveal.us.vzconnect.com/login.aspx?ReturnUrl=${revealLink}`;
  } else if (window.location.href.toString().includes("vccp-qa.ebiz.verizon.com")) {
    return "https://test.us.development.fleetmatics.com/en-US/myaccount-live/home";
  } else if (window.location.href.toString().includes("vccp-dev.ebiz.verizon.com")) {
    return "https://dev.development.fleetmatics.com/en-US/myaccount-live/home";
  } else if (window.location.href.toString().includes("localhost")) {
    return "https://dev.development.fleetmatics.com/en-US/myaccount-live/home";
  } else if (window.location.href.toString().includes("reveal.stage.eu.fleetmatics.com")) {
    return `https://reveal.stage.eu.fleetmatics.com/login.aspx?ReturnUrl=${revealLink}`;
  } else if (window.location.href.toString().includes("reveal.stage.eu.vzconnect.com")) {
    return `https://reveal.stage.eu.vzconnect.com/login.aspx?ReturnUrl=${revealLink}`;
  } else if (window.location.href.toString().includes("reveal.eu.fleetmatics.com")) {
    return `https://reveal.eu.fleetmatics.com/login.aspx?ReturnUrl=${revealLink}`;
  } else if (window.location.href.toString().includes("reveal.eu.vzconnect.com")) {
    return `https://reveal.eu.vzconnect.com/login.aspx?ReturnUrl=${revealLink}`;
  } else {
    return;
  }
};

export const revealLoginRedirectionLink = () => {
  if (window.location.href.toString().includes("vccp-uat.ebiz.verizon.com")) {
    return `https://reveal.stage.us.fleetmatics.com/login.aspx`;
  } else if (window.location.href.toString().includes("reveal.stage.us.fleetmatics.com")) {
    return `https://reveal.stage.us.fleetmatics.com/login.aspx`;
  } else if (window.location.href.toString().includes("reveal.stage.us.vzconnect.com")) {
    return `https://reveal.stage.us.vzconnect.com/login.aspx`;
  } else if (window.location.href.toString().includes("reveal.us.fleetmatics.com")) {
    return `https://reveal.us.fleetmatics.com/login.aspx`;
  } else if (window.location.href.toString().includes("reveal.us.vzconnect.com")) {
    return `https://reveal.us.vzconnect.com/login.aspx`;
  } else if (window.location.href.toString().includes("vccp-qa.ebiz.verizon.com")) {
    return `https://test.us.development.fleetmatics.com/login.aspx`;
  } else if (window.location.href.toString().includes("vccp-dev.ebiz.verizon.com")) {
    return `https://dev.development.fleetmatics.com/login.aspx`;
  } else if (window.location.href.toString().includes("localhost")) {
    return `https://dev.development.fleetmatics.com/login.aspx`;
  } else if (window.location.href.toString().includes("reveal.stage.eu.fleetmatics.com")) {
    return `https://reveal.stage.eu.fleetmatics.com/login.aspx`;
  } else if (window.location.href.toString().includes("reveal.stage.eu.vzconnect.com")) {
    return `https://reveal.stage.eu.vzconnect.com/login.aspx`;
  } else if (window.location.href.toString().includes("reveal.eu.fleetmatics.com")) {
    return `https://reveal.eu.fleetmatics.com/login.aspx`;
  } else if (window.location.href.toString().includes("reveal.eu.vzconnect.com")) {
    return `https://reveal.eu.vzconnect.com/login.aspx`;
  } else {
    return;
  }
}

export const helpNavigationHandler = (regionId, pendoTrackEventName, accountNumber, isSupport = false, onlyLink = false) => {
  const regionIds = [840, 124, 36, 554, 826, 528, 372, 250, 276, 56, 40, 380, 620, 724, 616];
  if (regionIds.includes(+regionId)) {
    pendoTrack(pendoTrackEventName, {
      status: "Success",
      accountId: accountNumber,
    });
    if (onlyLink) return helpNavigation(regionId, isSupport);
    else window.open(helpNavigation(regionId, isSupport), "_blank");
  } else {
    pendoTrack(pendoTrackEventName, {
      status: "Failed",
      accountId: accountNumber,
    });
  }
};

export const customerSupportLink = () => {
  let location = window.location.href.toString();
  if (location.includes("vccp-uat.ebiz.verizon.com")) {
    return "https://reveal.stage.us.fleetmatics.com/en-US/myaccount-live/contact-us";
  } else if (location.includes("reveal.stage.us.fleetmatics.com")) {
    return "https://reveal.stage.us.fleetmatics.com/en-US/myaccount-live/contact-us";
  } else if (location.includes("reveal.stage.us.vzconnect.com")) {
    return "https://reveal.stage.us.vzconnect.com/en-US/myaccount-live/contact-us";
  } else if (location.includes("reveal.us.fleetmatics.com")) {
    return "https://reveal.us.fleetmatics.com/en-US/myaccount-live/contact-us";
  } else if (location.includes("reveal.us.vzconnect.com")) {
    return "https://reveal.us.vzconnect.com/en-US/myaccount-live/contact-us";
  } else if (location.includes("vccp-qa.ebiz.verizon.com")) {
    return "https://test.us.development.fleetmatics.com/en-US/myaccount-live/contact-us";
  } else if (location.includes("vccp-dev.ebiz.verizon.com")) {
    return "https://dev.development.fleetmatics.com/en-US/myaccount-live/contact-us";
  } else if (location.includes("localhost")) {
    return "https://dev.development.fleetmatics.com/en-US/myaccount-live/contact-us";
  } else if (location.includes("reveal.stage.eu.fleetmatics.com")) {
    return "https://reveal.stage.eu.fleetmatics.com/en-US/myaccount-live/contact-us";
  } else if (location.includes("reveal.stage.eu.vzconnect.com")) {
    return "https://reveal.stage.eu.vzconnect.com/en-US/myaccount-live/contact-us";
  } else if (location.includes("reveal.eu.fleetmatics.com")) {
    return "https://reveal.eu.fleetmatics.com/en-US/myaccount-live/contact-us";
  } else if (location.includes("reveal.eu.vzconnect.com")) {
    return "https://reveal.eu.vzconnect.com/en-US/myaccount-live/contact-us";
  } else {
    return;
  }
};

export const onCloseRevealRedirectionLink = () => {
  let revealLanguage = Cookies.get("userLanguage") ? Cookies.get("userLanguage") : "en-US";
  if (window.location.href.toString().includes("vccp-uat.ebiz.verizon.com")) {
    return `https://reveal.stage.us.fleetmatics.com/${revealLanguage}/myaccount-live/home`;
  } else if (window.location.href.toString().includes("reveal.stage.us.fleetmatics.com")) {
    return `https://reveal.stage.us.fleetmatics.com/${revealLanguage}/myaccount-live/home`;
  } else if (window.location.href.toString().includes("reveal.stage.us.vzconnect.com")) {
    return `https://reveal.stage.us.vzconnect.com/${revealLanguage}/myaccount-live/home`;
  } else if (window.location.href.toString().includes("reveal.us.fleetmatics.com")) {
    return `https://reveal.us.fleetmatics.com/${revealLanguage}/myaccount-live/home`;
  } else if (window.location.href.toString().includes("reveal.us.vzconnect.com")) {
    return `https://reveal.us.vzconnect.com/${revealLanguage}/myaccount-live/home`;
  } else if (window.location.href.toString().includes("vccp-qa.ebiz.verizon.com")) {
    return `https://test.us.development.fleetmatics.com/${revealLanguage}/myaccount-live/home`;
  } else if (window.location.href.toString().includes("vccp-dev.ebiz.verizon.com")) {
    return `https://dev.development.fleetmatics.com/${revealLanguage}/myaccount-live/home`;
  } else if (window.location.href.toString().includes("localhost")) {
    return `https://dev.development.fleetmatics.com/${revealLanguage}/myaccount-live/home`;
  } else if (window.location.href.toString().includes("reveal.stage.eu.fleetmatics.com")) {
    return `https://reveal.stage.eu.fleetmatics.com/${revealLanguage}/myaccount-live/home`;
  } else if (window.location.href.toString().includes("reveal.stage.eu.vzconnect.com")) {
    return `https://reveal.stage.eu.vzconnect.com/${revealLanguage}/myaccount-live/home`;
  } else if (window.location.href.toString().includes("reveal.eu.fleetmatics.com")) {
    return `https://reveal.eu.fleetmatics.com/${revealLanguage}/myaccount-live/home`;
  } else if (window.location.href.toString().includes("reveal.eu.vzconnect.com")) {
    return `https://reveal.eu.vzconnect.com/${revealLanguage}/myaccount-live/home`;
  } else {
    return;
  }
};

export const handleOnCloseEvent = (revealLink) => {
  if (window.close() === undefined) {
    window.open(revealLink, "_self");
  } else {
    window.close();
  }
};

const findRevealRedirectionLink = (routeData, revealLanguage) => {
  const hash = "%2523";
  if (routeData === undefined || routeData === null || routeData === "") {
    return `%2F${revealLanguage}%2Fcustomer-portal%2F`;
  } else {
    return `%2F${revealLanguage}%2Fcustomer-portal%2F${hash}${encodeURIComponent(routeData)}`;
  }
};

export const findRoutingPath = (
  path,
  isNonERPCountryAcc
  // , regionId
) => {
  if (
    path === "/account/billing/invoice" &&
    !isNonERPCountryAcc
    // && regionId !== "554"
  ) {
    return "billingAndPayments";
  } else if (path === "/support/cases/caseList") {
    return "supportCases";
  } else if (path === "/account/myProfile/primaryAccount") {
    return "accountProfile";
  } else if (path.includes("/support/cases/viewCaseDetails")) {
    return path;
  } else if (path === "/account/myContract" && !isNonERPCountryAcc) {
    return "myContract";
  } else if (path === "/account/technicianAppointments" && !isNonERPCountryAcc) {
    return "technicianAppointments";
  } else if (path === "/account/technicianAppointments/transferDevice" && !isNonERPCountryAcc) {
    return path;
  } else if (path === "/account/technicianAppointments/removeDevice" && !isNonERPCountryAcc) {
    return path;
  } else if (path.includes("/account/technicianAppointments/viewAppointmentDetails")) {
    return path;
  } else if (path.includes("/account/technicianAppointments/reschedule")) {
    return path;
  } else if (
    path === "/account/billing/invoice/makepayment" &&
    !isNonERPCountryAcc
    //  && regionId !== "554"
  ) {
    return "makePayment";
  } else if (
    path === "/account/billing/invoice/managepayment" &&
    !isNonERPCountryAcc
    // && regionId !== "554"
  ) {
    return "managePayment";
  } else {
    return isNonERPCountryAcc
      ? // || regionId === "554"
        "supportCases"
      : "billingAndPayments";
  }
};

export const constructCaseHyperLink = (regionId) => {
  let revealLanguage = sessionStorage.getItem("revealUserLanguage") ? sessionStorage.getItem("revealUserLanguage") : "en-US";
  const NA_APAC_Ids = [840, 124, 36, 554];
  const EMEAIds = [250, 276, 372, 528, 826, 40, 56];
  if (EMEAIds.includes(+regionId)) {
    return ["eu", revealLanguage];
  } else if (NA_APAC_Ids.includes(+regionId)) {
    return ["us", revealLanguage];
  } else {
    return ["us", revealLanguage];
  }
};
